import type { ValueOrRefOrGetter } from '@/types'
import { isRef } from '@/composition/vue/compositionApi'

export const getValueFromRefOrGetter = <T>(rawValue: ValueOrRefOrGetter<T>): T => {
  if (isRef(rawValue)) {
    return rawValue.value
  }
  return rawValue instanceof Function ? rawValue() : rawValue
}
